import React from "react";
import * as R from "ramda";
import style from "./styles.scss";
import { connect } from "react-redux";
import { getters } from "../../model";
import * as PortalSelectors from "redux/modules/portal/selectors";
import moment from "moment";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";

import { TASK_TYPES } from "../../constants";

import { StatusComponent } from "Portal/NewPortal/Sections/Home/Cards/Tasks/View/Task";
import FileRequest from "./FileRequest";
import CustomTask from "./CustomTask";

const decorate = R.compose(
  connect(state => ({
    loading: getters.loading(state),
    taskData: getters.taskData(state),
    portal: PortalSelectors.portal(state)
  }))
);

const Header = ({ dueDate, open_label, status }) => {
  const taskCompletion = R.propOr("Complete", status, {
    not_submitted: "Incomplete",
    incomplete: "Incomplete",
    complete: "Completed",
    approved: "Completed",
    denied: "Denied",
    pending: "Pending"
  });

  return (
    <div className={style.row}>
      {dueDate ? (
        <div className={style.statusIcon}>
          {/* <div className={style.statusIconInner}></div> */}
          <QueryBuilderIcon style={{ fontSize: "14px", color: "#D0D0D0" }} />
        </div>
      ) : null}
      <div className={style.statusText}>{dueDate ? dueDate : null}</div>
      <div
        className={[
          style.statusTask,
          `${R.propOr("", open_label, {
            Open: style.open,
            Closed: style.closed
          })}`
        ].join(" ")}
      >
        {open_label ? open_label : "closed"}
      </div>
      <div className={style.actionRow}>
        <div className={style.actionButton}>
          <div className={style.actionContent}>
            <div className={style.actionIcon}>
              <StatusComponent
                status={status}
                open_label={open_label}
                fontSize={16}
              />
            </div>
            <div className={style.actionText}>{taskCompletion}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Details = ({ taskData = {}, loading = true, portal }) => {
  const {
    status,
    // is_complete,
    // due_label,
    due_raw,
    open_label,
    // is_required,
    type,
    description,
    meta = {}
  } = taskData || {};

  const timezone = R.path(["event", "timezone"])(portal);
  const timezoneFormatted = moment()
    .tz(timezone)
    .format("z");
  const formattedDueRaw = due_raw
    ? `${moment(due_raw)
        .tz(timezone)
        .format("[Due] MMM DD, YYYY [at] h:mm A")} (${timezoneFormatted})`
    : null;

  // const timezone = R.pathOr("America/Los_Angeles", ["event", "timezone"])(
  //   portal
  // );

  // const timezoneFormatted = moment()
  //   .tz(timezone)
  //   .format("z");

  // const startsAt = starts_at
  //   ? moment.tz(starts_at, timezone).format("ddd, MMM D, YYYY @ h:mm a") +
  //     ` (${timezoneFormatted})`
  //   : "-";

  // const endsAt = ends_at
  //   ? moment.tz(ends_at, timezone).format("ddd, MMM D, YYYY @ h:mm a") +
  //     ` (${timezoneFormatted})`
  //   : "-";

  const isClosed = open_label === "Closed";

  const body = R.prop(type, {
    [TASK_TYPES.DOCUMENT_REQUEST]: <FileRequest isClosed={isClosed} />,
    [TASK_TYPES.ASSIGNED_TASK]: (
      <CustomTask
        // completionMethod={meta?.completionMethod}
        description={description}
        url={meta?.url}
        isClosed={isClosed}
      />
    )
  });

  return (
    <div className={style.container}>
      {!loading && (
        <Header
          open_label={open_label}
          status={status}
          dueDate={formattedDueRaw}
        />
      )}
      {body}
    </div>
  );
};

export default decorate(Details);
